import { handleActions } from 'redux-actions';
import {
  setBeneficiarioEditar,
  setIndexBeneficiairoEditar,
  setShowFormActiom,
} from 'src/reducers/PaginaCompra/actions';
import { handleSetState } from '../utils';

const initialState = {
  showForm: true,

  beneficiario: null,
  indexEditar: null,
};

export type PaginaCompraStateType = typeof initialState;

const PaginaCompraReducer = handleActions<any, any>(
  {
    [setShowFormActiom as any]: handleSetState('showForm'),
    [setBeneficiarioEditar as any]: (state, { payload }) => ({
      ...state,
      beneficiario: payload,
    }),
    [setIndexBeneficiairoEditar as any]: (state, { payload }) => ({
      ...state,
      indexEditar: payload,
    }),
  },
  initialState,
);

export default PaginaCompraReducer;
